export function generateReactKey(str: string, maxLength = 10) {
  // replaces whitespace with '-'
  return str.replace(/\s/g, '-').substring(0, maxLength)
}
